import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SiteMarquee from './components/SiteMarquee';
import { useSiteConfig } from './contexts/SiteConfigContext';

export default function Navbar() {
  const { config } = useSiteConfig();
  const whatsappNumber = config?.contact?.whatsapp || "2250777880082";

  const [display, setDisplay] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const afficher = () => setDisplay(true);
  const affi = () => setDisplay(false);

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (!q) return;
    navigate(`/louer?q=${encodeURIComponent(q)}`);
    setSearchQuery("");
    setSearchOpen(false);
  };

  return (
    <div>
      {/* ── Marquee AU-DESSUS de la navbar ── */}
      <SiteMarquee />

      <header>
        <div className='navbar'>
          <div className="navbar--left">
            <Link className='liste' to="/">Accueil</Link>
            <Link className='liste' to="/louer">Locations</Link>
          </div>

          <div className='navbar--center'>
            <div className="navbar--logo">
              <Link to="/"><img src='/images/27.png' alt="Logo" /></Link>
            </div>
          </div>

          <div className="navbar--right">
            <div className="navbar--right--content">
              <Link className='liste' to="/contact">Contacts</Link>
              <Link className='liste' to="/about">L'agence</Link>

              {/* ── Barre de recherche ── */}
              <form
                onSubmit={handleSearch}
                className={`nb-search-form${searchOpen ? " nb-search-form--open" : ""}`}
              >
                {searchOpen && (
                  <input
                    autoFocus
                    type="text"
                    className="nb-search-input"
                    placeholder="Ville, type, quartier…"
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                    onBlur={() => { if (!searchQuery) setSearchOpen(false); }}
                  />
                )}
                <button
                  type={searchOpen ? "submit" : "button"}
                  className="nb-search-btn"
                  onClick={() => !searchOpen && setSearchOpen(true)}
                  aria-label="Rechercher un bien"
                >
                  <i className="fa-solid fa-magnifying-glass"></i>
                </button>
              </form>

              <div className="profile-dropdown"></div>
            </div>

            <div className='icons'>
              <div className='icon--menu' onClick={afficher}>
                <i className="fa-solid fa-bars"></i>
              </div>
            </div>
          </div>
        </div>

        {/* ── Sidebar mobile ── */}
        <div className={display ? "sidebar show-sidebar" : "sidebar"}>
          <div className='sidebar--menu'>
            <div className='btn--close--sidebar' onClick={affi}>✕</div>
            {/* Recherche mobile */}
            <form onSubmit={handleSearch} style={{ display: "flex", gap: 6, margin: "0.5rem 0 1rem" }}>
              <input
                type="text"
                placeholder="Rechercher un bien…"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                style={{ flex: 1, padding: "8px 12px", borderRadius: 8, border: "1px solid #d0daea", fontSize: "0.875rem", outline: "none" }}
              />
              <button type="submit" style={{ background: "#1B4F9E", color: "#fff", border: "none", borderRadius: 8, padding: "8px 12px", cursor: "pointer" }}>
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </form>
            <p><Link className='liste' to="/" onClick={affi}>Accueil</Link></p>
            <p><Link className='liste' to="/louer" onClick={affi}>Locations</Link></p>
            <p><Link className='liste' to="/contact" onClick={affi}>Contacts</Link></p>
            <p><Link className='liste' to="/about" onClick={affi}>L'agence</Link></p>
          </div>
        </div>
      </header>

      {/* ── Bouton WhatsApp flottant ── */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=Bonjour%20SCI%20MAYEDO%2C%20je%20suis%20int%C3%A9ress%C3%A9(e)%20par%20vos%20biens%20immobiliers.`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-btn"
        aria-label="Contacter via WhatsApp"
      >
        <i className="fa-brands fa-whatsapp"></i>
        <span className="whatsapp-float-label">WhatsApp</span>
      </a>

      {/* ── Bouton scroll to top ── */}
      {showScrollTop && (
        <button
          className="scroll-top-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          aria-label="Remonter en haut"
        >
          <i className="fa-solid fa-chevron-up"></i>
        </button>
      )}

      <style>{`
        /* ── Recherche navbar ── */
        .nb-search-form {
          display: flex;
          align-items: center;
          gap: 0;
          background: transparent;
          border-radius: 24px;
          transition: all 0.25s ease;
          overflow: hidden;
          max-width: 36px;
        }
        .nb-search-form--open {
          max-width: 260px;
          background: #fff;
          border: 1.5px solid #1B4F9E;
          box-shadow: 0 2px 12px rgba(27,79,158,0.15);
          padding-left: 12px;
        }
        .nb-search-input {
          border: none;
          outline: none;
          background: transparent;
          font-size: 0.875rem;
          color: #0f1f3d;
          width: 180px;
          padding: 6px 0;
        }
        .nb-search-btn {
          background: #1B4F9E;
          border: none;
          color: #fff;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 0.9rem;
          flex-shrink: 0;
          transition: background 0.18s ease;
        }
        .nb-search-btn:hover { background: #123371; }

        /* ── Dropdown profil ── */
        .profile-dropdown {
          position: relative;
          display: inline-block;
          z-index: 9999;
        }

        /* ── WhatsApp flottant ── */
        .whatsapp-float-btn {
          position: fixed;
          bottom: 2rem;
          left: 2rem;
          display: flex;
          align-items: center;
          gap: 10px;
          background: #25D366;
          color: #fff;
          text-decoration: none;
          padding: 13px 20px 13px 16px;
          border-radius: 50px;
          font-size: 1rem;
          font-weight: 700;
          box-shadow: 0 6px 24px rgba(37,211,102,0.4);
          z-index: 9999;
          transition: all 0.25s ease;
          animation: fadeInUp 0.3s ease;
        }
        .whatsapp-float-btn i {
          font-size: 1.5rem;
          flex-shrink: 0;
        }
        .whatsapp-float-label {
          font-size: 0.88rem;
          letter-spacing: 0.02em;
        }
        .whatsapp-float-btn:hover {
          background: #1ebe5d;
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(37,211,102,0.5);
        }
        .whatsapp-float-btn:active { transform: translateY(-1px); }

        @media (max-width: 640px) {
          .whatsapp-float-btn { padding: 13px; border-radius: 50%; }
          .whatsapp-float-label { display: none; }
        }

        /* ── Scroll to top ── */
        .scroll-top-btn {
          position: fixed;
          bottom: 2rem;
          right: 2rem;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: #1B4F9E;
          color: #fff;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.1rem;
          box-shadow: 0 6px 24px rgba(27,79,158,0.35);
          z-index: 9999;
          transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
          animation: fadeInUp 0.3s ease;
        }
        .scroll-top-btn:hover {
          background: #123371;
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(27,79,158,0.45);
        }
        .scroll-top-btn:active { transform: translateY(-1px); }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
